import { defer, Observable } from 'rxjs';
import { map } from 'rxjs';
import { ApolloClient } from '@apollo/client';
import { Deps } from 'src/types/global-types';
import mergeGuestCartMutation from 'src/queries/mergeGuestCart.graphql';

export function mergeGuestCart(sourceCartId: string, destinationCartId: string, deps: Deps): Observable<string> {
    const client = deps.client as ApolloClient<any>;
    return defer(() =>
        client.mutate({
            mutation: mergeGuestCartMutation,
            operationName: 'mergeGuestCart',
            variables: {
                sourceCartId,
                destinationCartId,
            },
        } as any),
    ).pipe(map((result: any) => result.data?.mergeCarts?.id || destinationCartId));
}
